import { createSelector } from '@ngrx/store';
import * as sharedState from '../reducers';
import * as legalEntitiesReducer from '../reducers/legal-entities.reducer';

export const selectLegalEntities = createSelector(
  sharedState.GetLegalEntitiesState,
  legalEntitiesReducer.getLegalEntitiesResponse
);

export const selectLegalEntitiesLoaded = createSelector(
  sharedState.GetLegalEntitiesState,
  legalEntitiesReducer.legalEntitiesLoaded
);
